import { Button, Flex, Image, Text } from '@chakra-ui/react';
import { links } from '@shared/utils';

export const Success = () => {
  const route = window.location.search;

  const email = route.split('=')[1];

  return (
    <Flex
      flexDir="column"
      w="full"
      p={{ base: 4, lg: 10 }}
      maxH="100dvh"
      h="100%"
      bg="brand.50"
    >
      <Flex flexDir="column" alignItems="center" gap={6} w="full" h="100dvh">
        <Image
          src="/images/logo-nexpro-connect.jpeg"
          blendMode="darken"
          h={90}
          objectFit="contain"
          mb={10}
          mt={10}
        />

        <Text size="2xl" fontWeight="semibold" maxW={800} textAlign="center">
          {`Recebemos o seu pedido e agora precisaremos confirmar alguns dados
          para darmos segmento a ativação da sua assinatura.`}
          <br />
          {`Enviamos um e-mail com o link de ativação da sua conta, acesse o
          e-mail ${email} para concluir sua contratação.`}
        </Text>

        <Button
          colorScheme="brand"
          size="lg"
          maxW={360}
          w="full"
          as="a"
          href={links.portal}
        >
          Voltar para o site
        </Button>
      </Flex>
    </Flex>
  );
};
